import { CANCELATION_REASONS_CATALOGUE } from '../../../../constants'
import { IInvoice } from 'models/invoices.models'
import { useCFDIsContainerContext } from 'containers/Invoices/CFDIs/CFDIsContainer/CFDIsContainer'
import SydDialog from 'components/Shared/SydDialog/SydDialog'
import IOCustomForm from 'components/FormComponents/IOComponents/IOCustomForm/IOCustomForm'
import AutocompleteField from 'components/FormComponents/IOComponents/AutocompleteField/AutoCompleteField'
import TextField from 'components/FormComponents/IOComponents/TextField/TextField'
import './styles.scss'

const CancelCFDIForm = () => {
  const {
    activeInvoice,
    cancelCFDIDialogOpen,
    cancelCfdiMutation,
    cancelReason,
    validDialog,
    updateState,
  } = useCFDIsContainerContext()

  const typedInvoice = activeInvoice as IInvoice

  return (
    <SydDialog
      open={cancelCFDIDialogOpen}
      className="dialog-invoices cancel-cfdi-form"
      title="Cancelar CFDI"
      subtitle="Selecciona un motivo de cancelación para este CFDI"
      primaryButtonText="Cancelar"
      loadingPrimaryButton={cancelCfdiMutation.isLoading}
      disablePrimaryButton={!validDialog}
      secondaryButtonText="Cerrar"
      disableSecondaryButton={cancelCfdiMutation.isLoading}
      onCancel={() => {
        updateState(draft => {
          draft.cancelCFDIDialogOpen = false
          draft.validDialog = false
          draft.cancelReason = null
        })
      }}
      form="cancelCFDIForm"
      sideButtons>
      <IOCustomForm
        id="cancelCFDIForm"
        onSubmit={async (form: any) => {
          if (!typedInvoice) return
          cancelCfdiMutation.mutate({
            invoice: typedInvoice,
            reason: form.reason.value,
            substitute: form.substitute,
          })
        }}
        onValidity={(v: boolean) =>
          updateState(draft => {
            draft.validDialog = v
          })
        }>
        <TextField
          name="uuid"
          label="UUID"
          value={typedInvoice?.uuid}
          disabled={cancelCfdiMutation.isLoading}
          inputProps={{ readOnly: true }}
          fullWidth
          required
        />
        <AutocompleteField
          name="reason"
          label="Motivo de Cancelación"
          catalogue={CANCELATION_REASONS_CATALOGUE}
          onChange={(v: any) =>
            updateState(draft => {
              draft.cancelReason = v
            })
          }
          disabled={cancelCfdiMutation.isLoading}
          fullWidth
          required
        />
        {typedInvoice?.version === '4' && cancelReason?.value === 1 && (
          <TextField
            name="substitute"
            label="Folio de sustitución"
            fieldType="foil"
            fullWidth
            required
          />
        )}
      </IOCustomForm>
    </SydDialog>
  )
}

export default CancelCFDIForm
